<template>
	<div v-if="submissionFlow && submissionFlow.isAvailable()" class="tool-work-submit-action-root text-center mt-4">
		<qw-button size="large" type="primary" :disabled="submissionFlow.isSubmitting()" @click="submissionFlow.request()">
			<span class="px-5">Submit</span>
		</qw-button>
	</div>
</template>

<script>
export default {
	name: "ToolWorkSubmitAction",
	inject: {submissionFlow: {from: "toolSubmissionFlow", default: null}},
}
</script>
